// extracted by mini-css-extract-plugin
export var checkboxAndFiletype = "styles-module__checkboxAndFiletype___CLEVO";
export var container = "styles-module__container___NyahI";
export var controls = "styles-module__controls___kaQ5i";
export var fileInformation = "styles-module__fileInformation___FwQZF";
export var fileName = "styles-module__fileName___cLchp";
export var fileSize = "styles-module__fileSize___VD1Q8";
export var fileType = "styles-module__fileType___dHQAF";
export var labelClassName = "styles-module__labelClassName___BqViM";
export var metaData = "styles-module__metaData___CvguS";
export var removeButton = "styles-module__removeButton___ETVGu";
export var successUpload = "styles-module__successUpload___nvQFh";